import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss']
})
export class LibraryComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public Form: FormGroup;
  // public homebanners=[];
  submitted = false;
  message = null;
  class = null;
  action = null;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      overview: ['', Validators.required],
      _id: [''],
    });
// console.log(this.api_endpoint);
    this.http.get<any>(this.api_endpoint+'/libraryfindone/').subscribe(
        data => {
          if(data.data != null){
            this.submitted = false;
            this.Form.patchValue({
              overview: data.data.overview,
              _id: data.data._id,
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(){
    // alert(action);
    // console.log(this.Form.value);

    
    if(this.submitted == false){
      var data = {
        "overview" : this.Form.value.overview,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.Form.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/library', data).subscribe(
        res => {
          // console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else{
      // alert(this.Form.value.overview);
      var data1 = {
        "overview" : this.Form.value.overview,
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/library', data1).subscribe(
        res => {
          // console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
